module.exports = __webpack_public_path__ + "public/img/campaign/2025/pt/mobile-app.png";